module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar selected;\nvar defaultOptionEntry = ((model.config || {}).renderConfig || {}).defaultOptionEntry;\n%>\n<select data-field-code=\"<%= model.fieldCode %>\" data-field-type=\"select\">\n<%\nif(defaultOptionEntry){\n%><option value=\"<%- defaultOptionEntry.value %>\"><%= defaultOptionEntry.name %></option><%\n}\nfor(var o in model.options || {}){\nselected = false;\nif((model.dataJSON || [])[0]){\nselected = model.dataJSON[0] == o;\n}\n%><option value=\"<%= o %>\"<%- selected ? ' SELECTED' : '' %>><%= model.options[o] %></option><%\n}\n%>\n</select>"
  , __filename = "components/templates/componentTrees/form/fields/componentSelect.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var selected;
var defaultOptionEntry = ((model.config || {}).renderConfig || {}).defaultOptionEntry;

    ; __line = 4
    ; __append("\n<select data-field-code=\"")
    ; __line = 5
    ; __append(escapeFn( model.fieldCode ))
    ; __append("\" data-field-type=\"select\">\n")
    ; __line = 6
    ; 
if(defaultOptionEntry){

    ; __line = 8
    ; __append("<option value=\"")
    ; __append( defaultOptionEntry.value )
    ; __append("\">")
    ; __append(escapeFn( defaultOptionEntry.name ))
    ; __append("</option>")
    ; 
}
for(var o in model.options || {}){
selected = false;
if((model.dataJSON || [])[0]){
selected = model.dataJSON[0] == o;
}

    ; __line = 15
    ; __append("<option value=\"")
    ; __append(escapeFn( o ))
    ; __append("\"")
    ; __append( selected ? ' SELECTED' : '' )
    ; __append(">")
    ; __append(escapeFn( model.options[o] ))
    ; __append("</option>")
    ; 
}

    ; __line = 17
    ; __append("\n</select>")
    ; __line = 18
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/componentTrees/form/fields/componentSelect.ejs

}